query TripBreakdownFilterCommonData {
  availableTripWorkgroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  availableTripBusinessUnits(orderBy: [NAME_ASC, PRIMARY_KEY_ASC]) {
    nodes {
      id
      name
    }
  }
  availableTripDepartments(orderBy: [NAME_ASC, PRIMARY_KEY_ASC]) {
    nodes {
      id
      name
    }
  }
  availableTripStatuses(orderBy: [STATUS_TYPE_ASC, PRIMARY_KEY_ASC]) {
    nodes {
      id
      statusType
    }
  }
  availableTripCurrencies(orderBy: [NAME_ASC, PRIMARY_KEY_ASC]) {
    nodes {
      id
      name
      isoCode
    }
  }
  travelPolicies(orderBy: DESCRIPTION_ASC) {
    nodes {
      id
      description
    }
  }
}
